import axios from 'axios';
import { getTokenSilent, myMSALObj, loginRequest } from '@/authConfig';
import { withRetry } from '@/utils/NetworkRetry';
let config: any;
// const idObjectAPP = '9efe727b-5d5c-43dc-b1e3-341c8a9f9ca8'; //Es el ID del objeto de la app enterprise para DEV;
// const idObjectAPP = '9efe727b-5d5c-43dc-b1e3-341c8a9f9ca8'; //Es el ID del objeto de la app enterprise para PRE;
const idObjectAPP = 'bf5eaaa2-bead-49fb-9611-d20b5b52ac8a'; //Es el ID del objeto de la app enterprise para PRO;
const apiUrlME = 'https://graph.microsoft.com/v1.0/me';
const apiUrlRoles = 'https://graph.microsoft.com/v1.0/servicePrincipals/' + idObjectAPP + '/appRoles';
const apiUrlappRoleAssignments = 'https://graph.microsoft.com/v1.0/users/';
// const token = sessionStorage.getItem("tokenKey");

async function handleAuthError(error: any) {
  console.warn("Auth error detected in AzureServices:", error);
  // Intentamos recuperar la sesión silenciosamente si es un 401 o falta token
  if (error === "No token" || (error.response && error.response.status === 401)) {
    try {
      const account = myMSALObj.getActiveAccount();
      await withRetry(() =>
        myMSALObj.ssoSilent({
          scopes: ['user.read'],
          loginHint: account?.username
        })
      );
      console.log("Session restored silently in AzureServices.");
      // No reintentamos la llamada original de Graph porque la UI suele montar todo
      // al principio. Si es crítico lo ideal sería que quien llama a AzureServices reintente.
      return;
    } catch (ssoError) {
      console.error("Failed to restore session silently in AzureServices.", ssoError);
      if (window.location.pathname !== '/login' && window.location.pathname !== '/Login') {
        window.location.href = '/login';
      }
    }
  }
}

export default {
  async getME() {
    let respuesta

    const token = await getTokenSilent();
    if (!token) {
      await handleAuthError("No token");
      return null;
    }

    await axios.get(apiUrlME, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then(response => {
        // Manipula los datos devueltos en la respuesta
        //console.log("prueba 1",response.data);
        respuesta = response.data.id
      })
      .catch(async error => {
        // Maneja cualquier error que ocurra durante la solicitud
        console.error(error);
        await handleAuthError(error);
      });

    return respuesta;
  },

  async getAllRoles() {
    let respuesta

    const token = await getTokenSilent();
    if (!token) {
      await handleAuthError("No token");
      return null;
    }

    await axios
      .get(apiUrlRoles, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        // Manipula los datos devueltos en la respuesta
        //console.log("prueba 1",response.data.value);
        respuesta = response.data.value;

        // console.log('roles usuario logado',respuesta);
      })
      .catch(async (error) => {
        // Maneja cualquier error que ocurra durante la solicitud
        console.error(error);
        await handleAuthError(error);
      });
    return respuesta;
  },

  async appRoleAssignments(idUser: string) {
    let respuesta

    const token = await getTokenSilent();
    if (!token) {
      await handleAuthError("No token");
      return null;
    }

    await axios
      .get(apiUrlappRoleAssignments + idUser + '/appRoleAssignments', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        // Manipula los datos devueltos en la respuesta
        respuesta = response.data.value;
      })
      .catch(async (error) => {
        // Maneja cualquier error que ocurra durante la solicitud
        console.error(error);
        await handleAuthError(error);
      });
    return respuesta;
  }
};
